'use client';

import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import LottieRender from './LottieRender';

const MissionValues = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useGSAP(() => {
        gsap.from(".mission-content", {
            x: -50,
            opacity: 0,
            duration: 1,
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top 70%",
            }
        });
        gsap.from(".mission-visual", {
            x: 50,
            opacity: 0,
            duration: 1,
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top 70%",
            }
        });
    }, { scope: containerRef });

    return (
        <section ref={containerRef} className="py-24 bg-white overflow-hidden relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">

                {/* Content */}
                <div className="mission-content relative z-10">
                    <span className="text-indigo-600 font-bold text-sm tracking-widest uppercase mb-4 block">
                        Our Mission
                    </span>
                    <h2 className="text-4xl lg:text-5xl font-black text-slate-900 mb-8 leading-tight">
                        Engineering the <br />
                        <span className="text-indigo-600">Digital Pulse</span> of Tomorrow.
                    </h2>
                    <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                        We don't just build websites; we construct living digital organisms. Our mission is to empower brands with self-sustaining, high-performance ecosystems that adapt and grow.
                    </p>
                    <ul className="space-y-4 mt-8">
                        {["Innovation First", "Transparent Process", "Scalable Growth"].map((item, i) => (
                            <li key={i} className="flex items-center space-x-3">
                                <span className="h-2 w-2 rounded-full bg-indigo-500" />
                                <span className="text-slate-800 font-semibold">{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Visual */}
                <div className="mission-visual h-[500px] w-full relative flex items-center justify-center">
                    {/* Circle (2).lottie */}
                    <div className="w-full h-full transform scale-125">
                        <LottieRender animationPath="/animations/mission_v2.json" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MissionValues;
